import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const AddTrackItem = styled.li`
  display: flex;
  align-items: center;
  align-self: center;
  color: ${colors.mainText};
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0px;
  }
`

export const AddTrackImg = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  align-self: center;
`

export const PlatformIcon = styled.div`
  align-self: center;
  display: flex;
  & img {
    min-height: 24px;
    min-width: 24px;
    height: 24px;
    width: 24px;
    margin-right: 8px;
  }
`

export const NoTrack = styled.div`
  line-height: 21px;
`

export const AddTrackInfo = styled.div`
  display: flex;

  @media ${device.mobileMin} {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
  }
`

export const AddTrackUrl = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 16px;
`

export const AddTrackInfoDescr = styled.div`
  padding: 0px;
  margin-bottom: 0px;
`

export const AddTrackInfoTitle = styled.div`
  font-weight: 600;
  line-height: 21px;
`
